import get from 'lodash/get';
import { PATCH_FILE_ID_BATCH_SIZE } from '../../../constants';

class BoxFileQueue {
  queue = [];

  workingOnPromise = false;

  patchCall;

  dequeuePatchList(size) {
    if (this.queue.length === 0) return null;
    const patchFileIdList = [];
    let remainSize = size;
    while (this.queue.length > 0 && remainSize > 0) {
      const item = this.queue.shift();
      remainSize -= 1;
      patchFileIdList.push(item);
    }
    return patchFileIdList;
  }

  size() {
    return this.queue.length;
  }

  enqueue(itemFile) {
    this.queue.push(itemFile);
    this.dequeue();
  }

  setPatchCall(patchCall) {
    if (this.patchCall) return;
    this.patchCall = patchCall;
  }

  dequeue() {
    if (this.workingOnPromise) {
      return false;
    }
    const patchFileIdList = this.dequeuePatchList(PATCH_FILE_ID_BATCH_SIZE);
    if (patchFileIdList) {
      // create payload of list of file patch id objcet
      const payload = patchFileIdList.map(itemToPatchId => ({
        elementId: itemToPatchId.elementId,
        localPath: itemToPatchId.file.name,
        size: get(itemToPatchId, 'size', null),
        file: {
          type: 'file',
          id: itemToPatchId.boxFile.id,
        },
      }));

      try {
        this.workingOnPromise = true;
        // create a call to patch the file ids in batch on form response.
        this.patchCall(payload)
          .then(() => {
            this.workingOnPromise = false;
            this.dequeue();
          })
          .catch(() => {
            this.workingOnPromise = false;
            this.dequeue();
          });
      } catch (err) {
        this.workingOnPromise = false;
        this.dequeue();
      }
    }
    return true;
  }
}

export { BoxFileQueue };
export default BoxFileQueue;
